import {
    FilterData,
    FilterBlockTypesEnum,
} from "../../src/apis/stateful-content";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;

const response: FilterData = {
    filterBlocks: [
        {
            type: FilterBlockTypesEnum.Dropdown,
            name: "equipment",
            filterable: true,
            filterItems: [
                {
                    name: "TWDEDEMO028",
                    value: "TWDEDEMO028",
                    label: "Maschinenalias TruEquipment 1 (TWDEDEMO028) (6)",
                },
                {
                    name: "TWDEDEMO011",
                    value: "TWDEDEMO011",
                    label: "TruEquipmen 2 (TWDEDEMO011) (2)",
                },
                {
                    name: "TWDEDEMO012",
                    value: "TWDEDEMO012",
                    label: "TruEquipmen 3 (TWDEDEMO012) (2)",
                },
                {
                    name: "TWDEDEMO013",
                    value: "TWDEDEMO013",
                    label: "TruEquipmen 4 (TWDEDEMO013) (2)",
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Select,
            name: "status",
            multiple: true,
            options: [
                { value: "ORDER_ORDERED" },
                {
                    value: "ORDER_IN_PROGRESS",
                },
                {
                    value: "ORDER_CANCELLED",
                },
                {
                    value: "ORDER_PARTLY_SENT",
                },
                {
                    value: "ORDER_COMPLETE",
                },
                {
                    value: "ORDER_RECEIVED",
                },
                {
                    value: "ORDER_UNKNOWN",
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Select,
            placeholder: "Eingangsart",
            name: "entryPoint",
            multiple: true,
            options: [
                {
                    value: "entry-point_1",
                },
                {
                    value: "entry-point_2",
                },
                {
                    value: "entry-point_3",
                },
                {
                    value: "entry-point_4",
                    disabled: true,
                },
            ],
        },
    ],
};

const writeToFile = (object: FilterData, name: string) => {
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

writeToFile(response, "myorders-filter");
